export default "__VITE_ASSET__DqFLGWwU__"